import React, { useEffect, useState } from 'react';
import { AxiosError } from 'axios';
import { toast } from 'react-toastify';
import { States } from '@/helpers/common/states';
import Communication from '@/model/Communication';
import { useHistory, useParams } from 'react-router-dom';
import { communicationService } from '../../services';
import { CommunicationViewUI } from './ui';

export const CommunicationViewScreen: React.FC = (): JSX.Element => {
  const navigate = useHistory();
  const { id } = useParams<{ id: string }>();

  const [state, setState] = useState<States>(States.default);
  const [communication, setCommunication] = useState<Communication | null>(null);

  const handleGetCommunication = async (): Promise<void> => {
    if (!id) {
      toast.error('Campanha não informada');
      navigate.replace('/communication-list');
      return;
    }

    try {
      setState(States.loading);

      const data = await communicationService.findById(id);
      setCommunication(data);
    } catch (error) {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(err.response?.data?.message || err.message || 'Erro ao buscar campanha');
      navigate.replace('/communication-list');
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    handleGetCommunication();
  }, [id]);

  return (
    <CommunicationViewUI
      state={state}
      communication={communication}
      onBack={() => navigate.replace('/communication-list')}
      onEdit={() => {
        if (communication?.id) {
          navigate.replace(`/communication/${communication.id}/edit`);
        }
      }}
    />
  );
};
